import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "mt20 flex-m-between"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("批量删除");

var _hoisted_3 = ["onClick"];
import authWrap from './components/authWrap';
import commonTable from './components/commonTable';
import { ref, reactive, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import AuthService from '@/api/auth';
import { ElMessage, ElMessageBox } from 'element-plus';
import DtMessage from '@/components/DtMessage';
import { asyncComputed } from '@vueuse/core';
import { getAuthListConfig } from './commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window$AppConfig$aut;

    var route = useRoute();
    var searchParams = reactive({
      appKey: route.params.project || 'beacon_olap',
      bizId: route.params.biz_url,
      assetKey: '',
      baseTargetType: 'USER',
      targetUserId: route.params.userId,
      targetUserName: route.params.userName,
      keyword: '',
      pageNo: 1,
      pageSize: 10
    }); // 权限类型列表

    var authTypes = asyncComputed(function () {
      return getAuthListConfig({
        appKey: searchParams.appKey,
        categoryKey: searchParams.assetKey
      });
    });
    var tableOptions = reactive({
      loading: false,
      pagination: true,
      total: 0,
      noExpand: true,
      selection: true,
      selectedRow: []
    });
    var tableHeader = ref([{
      title: '用户名',
      key: 'memberName'
    }, {
      title: 'ID',
      key: 'id',
      width: 100
    }, {
      title: '数据资产内容',
      key: 'name',
      preIcon: 'FolderOpened',
      iconShowKey: 'dir',
      iconShowValue: true
    }]);
    var tableBody = ref([]);
    var dataTypes = ref([]);
    var tabTypes = ref([{
      label: '个人权限',
      value: 'USER'
    }, {
      label: '继承角色组的权限',
      value: 'ROLE'
    }]);

    if ((_window$AppConfig$aut = window.AppConfig.auth) !== null && _window$AppConfig$aut !== void 0 && _window$AppConfig$aut.showOrg) {
      tabTypes.value.push({
        label: '继承组织架构的权限',
        value: 'ORG'
      });
    }

    var headerText = reactive({
      USER: '用户名',
      ROLE: '角色组',
      ORG: '组织架构'
    });

    var searchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var _data$data;

        var data, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tableOptions.loading = true;
                tableOptions.selectedRow = [];
                if (params === undefined) searchParams.pageNo = 1;
                if (params !== null && params !== void 0 && params.pageNo) searchParams.pageNo = params.pageNo;
                if (params !== null && params !== void 0 && params.pageSize) searchParams.pageSize = params.pageSize;
                _context.next = 7;
                return AuthService.queryAssetByPageWithPerm(_objectSpread(_objectSpread({}, searchParams), params));

              case 7:
                data = _context.sent;
                tableOptions.loading = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  tableOptions.total = result.totalCount;
                  result.itemList.forEach(function (item) {
                    item.authDisabled = true;

                    if (searchParams.baseTargetType === 'USER') {
                      item.memberName = searchParams.targetUserId;
                    } else if (item.member) {
                      item.memberName = item.member.memberName;
                    }
                  });
                  tableBody.value = result.itemList;
                } else {
                  tableOptions.total = 0;
                  tableBody.value = [];
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var userDisplayedInfo = computed(function () {
      return window.AppConfig.isCloudVersion ? searchParams.targetUserName : searchParams.targetUserId;
    });

    var handleSelectHandler = function handleSelectHandler(selection) {
      tableOptions.selectedRow = selection;
    };

    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data2, _dataTypes$value;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AuthService.getListBaseInfoByAppkey({
                  appKey: searchParams.appKey
                });

              case 2:
                data = _context2.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  dataTypes.value = data.data.result;
                }

                if (!(((_dataTypes$value = dataTypes.value) === null || _dataTypes$value === void 0 ? void 0 : _dataTypes$value.length) > 0)) {
                  _context2.next = 10;
                  break;
                }

                searchParams.assetKey = dataTypes.value[0].assetKey;
                _context2.next = 8;
                return searchList();

              case 8:
                _context2.next = 13;
                break;

              case 10:
                searchParams.assetKey = '';
                tableBody.value = [];
                dataTypes.value = [];

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var changeTab = function changeTab() {
      tableHeader.value[0].title = headerText[searchParams.baseTargetType];

      if (searchParams.baseTargetType === 'USER') {
        tableOptions.selection = true;
      } else {
        tableOptions.selection = false;
      }

      searchList();
    };

    var changeAuth = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(rows, grantModel) {
        var _data$data3;

        var data, _data$data4;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return AuthService.grantAsset({
                  appKey: searchParams.appKey,
                  assetKey: searchParams.assetKey,
                  bizId: searchParams.bizId,
                  grantModel: grantModel,
                  userIds: [searchParams.targetUserId],
                  nodeInfos: rows
                });

              case 2:
                data = _context3.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  searchList();
                } else {
                  DtMessage({
                    type: 'warning',
                    message: (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.msg
                  });
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function changeAuth(_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    var deleteAuth = function deleteAuth(row) {
      ElMessageBox.confirm("\u4F60\u786E\u5B9A\u8981\u79FB\u9664".concat(searchParams.targetUserId, "\u7684\u3010").concat(row.name, "\u3011\u7684\u6743\u9650\u5417\uFF1F"), '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        changeAuth([row], 'REMOVE');
      });
    };

    var batchDelete = function batchDelete() {
      var selectedRow = tableOptions.selectedRow;

      if (selectedRow.length === 0) {
        ElMessage.error('请至少选择一个数据资产内容');
        return;
      }

      ElMessageBox.confirm("\u4F60\u786E\u5B9A\u8981\u79FB\u9664".concat(searchParams.targetUserId, "\u7684\u6240\u9009\u7684").concat(selectedRow.length, "\u4E2A\u6570\u636E\u8D44\u4EA7\u5185\u5BB9\u7684\u6743\u9650\u5417\uFF1F"), '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        changeAuth(selectedRow, 'REMOVE');
      });
    };

    watch(function () {
      return route.params.project;
    }, function () {
      searchParams.appKey = route.params.project || 'beacon_olap';
      initData();
    });
    onMounted(function () {
      initData();
    });
    return function (_ctx, _cache) {
      var _component_el_radio_button = _resolveComponent("el-radio-button");

      var _component_el_radio_group = _resolveComponent("el-radio-group");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      var _component_edit_pen = _resolveComponent("edit-pen");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createBlock(_unref(authWrap), {
        "search-params": _unref(searchParams)
      }, {
        titleCon: _withCtx(function () {
          return [_createElementVNode("h2", null, [_createElementVNode("a", {
            class: "link1",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.$router.push({
                name: 'BizMemberManager'
              });
            })
          }, "空间成员管理"), _createTextVNode(" >> " + _toDisplayString(_unref(userDisplayedInfo)) + ": 数据资产授权管理 ", 1)])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_radio_group, {
            modelValue: _unref(searchParams).baseTargetType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _unref(searchParams).baseTargetType = $event;
            }),
            onChange: _cache[2] || (_cache[2] = function ($event) {
              return changeTab();
            })
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabTypes.value, function (item) {
                return _openBlock(), _createBlock(_component_el_radio_button, {
                  label: item.value,
                  key: item.value
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item.label), 1)];
                  }),
                  _: 2
                }, 1032, ["label"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
            class: "input-with-select w500 mb10",
            placeholder: "请输入数据资产名称或ID进行搜索",
            modelValue: _unref(searchParams).keyword,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return _unref(searchParams).keyword = $event;
            }),
            onChange: _cache[6] || (_cache[6] = function ($event) {
              return searchList();
            }),
            clearable: ""
          }, {
            prepend: _withCtx(function () {
              return [_createVNode(_component_el_select, {
                modelValue: _unref(searchParams).assetKey,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return _unref(searchParams).assetKey = $event;
                }),
                class: "w150",
                onChange: _cache[4] || (_cache[4] = function ($event) {
                  return searchList();
                }),
                placeholder: "选择资产类型"
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTypes.value, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.assetName,
                      value: item.assetKey,
                      key: item.assetKey
                    }, null, 8, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }, 8, ["modelValue"]), _unref(tableOptions).selection ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: batchDelete
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          })) : _createCommentVNode("", true)]), _createVNode(_unref(commonTable), {
            params: _unref(searchParams),
            options: _unref(tableOptions),
            "table-header": tableHeader.value,
            "table-body": tableBody.value,
            onHandleSelect: handleSelectHandler,
            onOnChangePage: searchList
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                label: "权限类型",
                width: "150"
              }, {
                default: _withCtx(function (scope) {
                  return [_createVNode(_component_el_select, {
                    modelValue: scope.row.dataAssetAction,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return scope.row.dataAssetAction = $event;
                    },
                    class: "w100",
                    disabled: scope.row.authDisabled,
                    onChange: function onChange($event) {
                      return changeAuth(scope.row, 'MODIFY');
                    }
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authTypes), function (_ref4) {
                        var desc = _ref4.desc,
                            key = _ref4.key;
                        return _openBlock(), _createBlock(_component_el_option, {
                          label: desc,
                          value: key,
                          key: key
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]), _unref(searchParams).baseTargetType === 'USER' && scope.row.authDisabled ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "el-icon-edit ml10",
                    onClick: function onClick($event) {
                      return scope.row.authDisabled = false;
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_edit_pen)];
                    }),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true)];
                }),
                _: 1
              }), _unref(searchParams).baseTargetType === 'USER' ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                width: "100"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("a", {
                    class: "link1 red",
                    onClick: function onClick($event) {
                      return deleteAuth(scope.row);
                    }
                  }, "移除权限", 8, _hoisted_3)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["params", "options", "table-header", "table-body"])];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});